import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { BackendService } from './backend.service';
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';
import { HttpService } from './http.service';
import { ValidateLoyaltyService } from './validate-loyalty.service';
import { GetRoomsResponse } from 'app/model/wbe/backend-api-response/get-rooms-response';
import { GetAdvancedFilterDataResponse } from 'model/shared/backend-api-response/get-advanced-filter-data-response';
@Injectable()
export class RoomlistService {
  private property_name: string;
  private server_name: string;
  private playerHistory: string;
  public errorMessage: string;
  public casinoPlayerloginCall = new BehaviorSubject<boolean>(false);
  public offerSelectedfromoffersAPI = new BehaviorSubject<boolean>(true);
  private timeout = new BehaviorSubject<string>('none');
  public roomlistFilter = new BehaviorSubject<any>('none');
  timeoutchange = this.timeout.asObservable();
  private serverRoomname: string;
  public tenantId: any;
  constructor(
    private _http: HttpClient,
    private configservice: LegacyBookInitService,
    public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    public CommonService: LegacyBookInitService,
    public groupBackend: BackendService,
    private httpService: HttpService,
    public loyaltyService: ValidateLoyaltyService
  ) {
    this.tenantId = this.configservice.gettenantId();
    this.property_name = configservice.PropertyData.PropNameKeyList.rateslist;
    this.server_name = configservice.getserverDetails_room();
    this.serverRoomname = configservice.PropertyData.PropNameKeyList.roomdescription;
    this.playerHistory = configservice.PropertyData.PropNameKeyList.history;
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  filterRooms(filter, filtervalue, rooms) {
    let fiterarray = Object.assign([], rooms);
    filter.forEach((ele) => {
      if (
        filtervalue[`searchText${ele.mappingField}${ele.order}`] &&
        filtervalue[`searchText${ele.mappingField}${ele.order}`] != 'undefined'
      ) {
        fiterarray = fiterarray.filter(
          this.includesWith(ele.mappingField, filtervalue[`searchText${ele.mappingField}${ele.order}`], ele.filterMatch)
        );
      }
    });
    return fiterarray;
  }

  includesWith(wordToCompare, value, matchFilter) {
    return (element) => {
      if (typeof element.amenities === 'undefined') {
        element.amenities = [];
      }
      if (typeof element[wordToCompare] === 'undefined') {
        return true;
      } else if (matchFilter == 'inBetween') {
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          let minValue = Number(value.split('-')[0]);
          let maxValue = Number(value.split('-')[1]);
          return minValue <= element[wordToCompare] && maxValue >= element[wordToCompare];
        }
      } else if (Array.isArray(element[wordToCompare])) {
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          return element[wordToCompare].includes(value);
        }
      } else if (
        matchFilter == 'greaterThanEqualTo' &&
        (typeof element[wordToCompare] === 'number' || element[wordToCompare] instanceof Number)
      ) {
        console.log('ge', value, element[wordToCompare]);
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          return value <= element[wordToCompare];
        }
      } else if (matchFilter == 'greaterThan' && (typeof element[wordToCompare] === 'number' || element[wordToCompare] instanceof Number)) {
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          return value < element[wordToCompare];
        }
      } else if (
        matchFilter == 'lesserThanEqualTo' &&
        (typeof element[wordToCompare] === 'number' || element[wordToCompare] instanceof Number)
      ) {
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          return value >= element[wordToCompare];
        }
      } else if (matchFilter == 'lesserThan' && (typeof element[wordToCompare] === 'number' || element[wordToCompare] instanceof Number)) {
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          return value > element[wordToCompare];
        }
      } else if (matchFilter == 'equalTo' && (typeof element[wordToCompare] === 'number' || element[wordToCompare] instanceof Number)) {
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          return value == element[wordToCompare];
        }
      } else if (matchFilter == 'contains') {
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          if (typeof element[wordToCompare] === 'boolean') {
            return value.toLowerCase() === 'all' ? true : (value.toLowerCase() === 'true' ? true : false) === element[wordToCompare];
          } else {
            return element[wordToCompare].toLowerCase().indexOf(value.toLowerCase()) > -1;
          }
        }
      } else if (matchFilter == 'exact') {
        if (Array.isArray(value)) {
          return this.multiValueCheck(value, element, wordToCompare, matchFilter);
        } else {
          //  return new RegExp( '\\b' + value + '\\b', 'gi').test(element[wordToCompare]);
          if (typeof element[wordToCompare] === 'boolean') {
            return value.toLowerCase() === 'all' ? true : (value.toLowerCase() === 'true' ? true : false) === element[wordToCompare];
          } else {
            return value.toLowerCase() === element[wordToCompare].toLowerCase();
          }
        }
      }
    };
  }

  multiValueCheck(value, element, wordToCompare, matchFilter) {
    const newCondition = [];
    value.forEach((ele, index, arr) => {
      if (matchFilter == 'inBetween') {
        let minValue = Number(ele.split('-')[0]);
        let maxValue = Number(ele.split('-')[1]);
        newCondition.push(minValue <= element[wordToCompare] && maxValue >= element[wordToCompare]);
      } else if (matchFilter == 'greaterThanEqualTo') {
        if (Array.isArray(element[wordToCompare])) {
          newCondition.push(element[wordToCompare].find((val) => val <= value));
        } else {
          newCondition.push(ele <= element[wordToCompare]);
        }
      } else if (matchFilter == 'greaterThan') {
        if (Array.isArray(element[wordToCompare])) {
          newCondition.push(element[wordToCompare].find((val) => val < value));
        } else {
          newCondition.push(ele < element[wordToCompare]);
        }
      } else if (matchFilter == 'lesserThanEqualTo') {
        if (Array.isArray(element[wordToCompare])) {
          newCondition.push(element[wordToCompare].find((val) => val >= value));
        } else {
          newCondition.push(ele >= element[wordToCompare]);
        }
      } else if (matchFilter == 'lesserThan') {
        if (Array.isArray(element[wordToCompare])) {
          newCondition.push(element[wordToCompare].find((val) => val > value));
        } else {
          newCondition.push(ele > element[wordToCompare]);
        }
      } else if (matchFilter == 'equalTo') {
        if (Array.isArray(element[wordToCompare])) {
          newCondition.push(element[wordToCompare].find((val) => val == value));
        } else {
          newCondition.push(ele == element[wordToCompare]);
        }
      } else if (matchFilter == 'contains') {
        if (Array.isArray(element[wordToCompare])) {
          newCondition.push(element[wordToCompare].includes(ele));
        } else {
          newCondition.push(element[wordToCompare].toLowerCase().indexOf(ele.toLowerCase()) > -1);
        }
      } else if (matchFilter == 'exact') {
        // newCondition.push(new RegExp( '\\b' + ele + '\\b', 'gi').test(element[wordToCompare]))
        if (Array.isArray(element[wordToCompare])) {
          newCondition.push(element[wordToCompare].includes(ele));
        } else {
          newCondition.push(ele.toLowerCase() === element[wordToCompare].toLowerCase());
        }
      }
    });
    var newResult = newCondition.reduce((previousCond, actualCond) => previousCond || actualCond, false);
    // var newResult = newCondition.reduce((previousCond, actualCond) =>
    // previousCond && actualCond, true);
    if (value.length == 0) {
      newResult = true;
    }
    return newResult;
  }

  getRooms(
    arrivalDate,
    departureDate,
    offerCode,
    CasinoNumber,
    guestDetailCount,
    firstName,
    lastName,
    refineSearch,
    groupCode?
  ): Observable<GetRoomsResponse> {
    let trips = 1,
      guestCount;
    if (CasinoNumber == '') {
      CasinoNumber = 'NA';
    }
    offerCode = encodeURIComponent(offerCode);
    if (groupCode) groupCode = encodeURIComponent(groupCode);
    firstName = firstName ? encodeURIComponent(firstName) : '';
    lastName = lastName ? encodeURIComponent(lastName) : '';
    let url;
    let paramsString;
    paramsString = JSON.parse(JSON.stringify(this.configservice.serviceHeaders));
    if (refineSearch) {
      let params = new HttpParams();
      this.configservice.guestTypeLimit.forEach((element) => {
        if (element['selectedValue'] && Number(element['selectedValue']) > 0 && element['key'] !== 'adults') {
          params = params.set(element.key, element.selectedValue);
          console.log(params);
        } else if (element['key'] === 'adults') {
          guestCount = element['selectedValue'];
        }
      });
      if (this.groupBackend.confidentialRate == 'Y') {
        params = params.set('confidentialRate', 'true');
      }
      paramsString.params = params;
    } else {
      guestCount = guestDetailCount;
      let params = new HttpParams();
      if (this.groupBackend.confidentialRate == 'Y') {
        params = params.set('confidentialRate', 'true');
        paramsString.params = params;
      }
    }

    url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.property_name +
      '/offerPropertyName/' +
      this.serverRoomname +
      '/historyPropertyName/' +
      this.playerHistory +
      '/arrivalDate/' +
      arrivalDate +
      '/departureDate/' +
      departureDate +
      '/casinoAccountNumber/' +
      CasinoNumber +
      '/trips/' +
      trips +
      '/adults/' +
      guestCount +
      '/firstName/' +
      (firstName || 'NA') +
      '/lastName/' +
      (lastName || 'NA') +
      '?appName=wbe&roomType=NA&locale=' +
      this.configservice?.PropertyData?.langCode +
      '&offer=' +
      offerCode +
      (groupCode ? `&groupCode=${groupCode}` : '');
    return this.httpService.get(url, paramsString).pipe(
      tap((data) => {
        console.log(data);
        let gtmData = {};
        if (data['Success']) {
          let roomData = [];
          let responseData = data['offers'] && data['offers'].length > 0 ? data['offers'][0] : null;
          if (responseData && responseData.roomTypes && responseData.roomTypes.length > 0)
            responseData.roomTypes = responseData.roomTypes.map((res) => {
              roomData.push({
                roomType: res.roomType,
                roomCode: res.roomCode,
                price: res.roomTotal,
                grandTotalPrice: res.quoteGrandTotal,
              });
              return res;
            });
          gtmData = {
            event: 'rateDetails',
            startDate: arrivalDate,
            endDate: departureDate,
            hotelId: data['property'],
            currencyCode: this.configservice.PropertyData.currencyCode,
            roomTypes: roomData,
            casinoId: this.loyaltyService.playerDetails?.casinoNumber || 'NA',
            emailAddress: this.loyaltyService.playerDetails?.emailAddress || 'NA',
          };
        } else {
          gtmData = {
            event: 'rateDetails',
            startDate: arrivalDate,
            endDate: departureDate,
            hotelId: data['property'],
            currencyCode: this.configservice.PropertyData.currencyCode,
            casinoId: this.loyaltyService.playerDetails?.casinoNumber || 'NA',
            emailAddress: this.loyaltyService.playerDetails?.emailAddress || 'NA',
          };
        }
        this.googleAnalyticsEventsService.pushGTAToDataLayer(gtmData);
      }),
      catchError(this.handleError('getOffers', []))
    );
  }
  private errorHandle = (error) => {
    if (error.message == 'Timeout') {
      this.timeout.next(error.Message);
    } else {
      error = error.json();
      console.log(error);
      this.errorMessage = error.ErrorMessage;
    }
  };
  getAdvanceFilterData() {
    let url =
      this.configservice.getCloudDomainName() +
      '/' +
      'wbe-admin-service/filtercfg/tenants/' +
      this.configservice.tenantId +
      '?tenantId=' +
      this.configservice.tenantId +
      '&propertyId=' +
      this.configservice.propertyId +
      '&containerName=' +
      this.configservice.appName +
      '&locale=' +
      this.configservice?.PropertyData?.langCode.toLowerCase();
    return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
      tap((data: GetAdvancedFilterDataResponse) => console.log(data)),
      catchError(this.handleError('getFilters', []))
    );
  }
}
